import { ReactElement } from 'react'

import Icon from '@ant-design/icons'

import { IconProps } from '../localTypes'

import ExternalLinkIconSvg from './ExternalLinkIconSvg'

const ExternalLinkIcon = (props: IconProps): ReactElement => (
    <Icon component={ExternalLinkIconSvg} {...props} />
)

export default ExternalLinkIcon
